module.exports = __webpack_public_path__ + "img/img_interview.fefdbd2b.png";